import { IStyledOption } from '@app/framework/constants/documents.constants';
import { OPTIONS } from '@app/framework/constants/options-list.constants';
import { Tab, RFI_TABS } from '@app/framework/underline-tabs/underline-tabs.types';
import { RFI_STATUS } from '@app/store/rfis/rfi.types';

export const RFI_OPTIONS_MANAGER_NO_ANSWER_DRAFT: IStyledOption[] = [
  { value: OPTIONS.MARK_OPEN, customClass: '', icon: '' },
  { value: OPTIONS.ADD_ANSWER, customClass: 'disabled', icon: '' },
  { value: OPTIONS.EDIT_RFI, customClass: '', icon: '' },
  { value: OPTIONS.EDIT_QUESTION, customClass: '', icon: '' },
  { value: OPTIONS.DOWNLOAD_COVER, customClass: '', icon: '' },
  { value: OPTIONS.VOID, customClass: '', icon: '' },
  { value: OPTIONS.DELETE, customClass: '', icon: '' },
];

export const RFI_OPTIONS_MANAGER_NO_ANSWER: IStyledOption[] = [
  { value: OPTIONS.ADD_ANSWER, customClass: '', icon: '' },
  { value: OPTIONS.EDIT_RFI, customClass: '', icon: '' },
  { value: OPTIONS.EDIT_QUESTION, customClass: '', icon: '' },
  { value: OPTIONS.DOWNLOAD_COVER, customClass: '', icon: '' },
  { value: OPTIONS.VOID, customClass: '', icon: '' },
  { value: OPTIONS.DELETE, customClass: 'disabled text-navy-500', icon: '' },
];

export const RFI_OPTIONS_MANAGER_ANSWERED_BY_OTHER_USER: IStyledOption[] = [
  { value: OPTIONS.APPROVE_ANSWER, customClass: '', icon: '' },
  { value: OPTIONS.ADD_ANSWER, customClass: '', icon: '' },
  { value: OPTIONS.EDIT_RFI, customClass: '', icon: '' },
  { value: OPTIONS.EDIT_QUESTION, customClass: '', icon: '' },
  { value: OPTIONS.DOWNLOAD_COVER, customClass: '', icon: '' },
  { value: OPTIONS.VOID, customClass: '', icon: '' },
  { value: OPTIONS.DELETE, customClass: 'disabled text-navy-500', icon: '' },
];

export const RFI_OPTIONS_MANAGER_AND_RESPONSIBLE_ANSWERED: IStyledOption[] = [
  { value: OPTIONS.APPROVE_ANSWER, customClass: '', icon: '' },
  { value: OPTIONS.EDIT_ANSWER, customClass: '', icon: '' },
  { value: OPTIONS.EDIT_RFI, customClass: '', icon: '' },
  { value: OPTIONS.EDIT_QUESTION, customClass: '', icon: '' },
  { value: OPTIONS.DOWNLOAD_COVER, customClass: '', icon: '' },
  { value: OPTIONS.VOID, customClass: '', icon: '' },
  { value: OPTIONS.DELETE, customClass: 'disabled text-navy-500', icon: '' },
];

export const RFI_OPTIONS_MANAGER_HAS_ANSWER_NON_APPROVED: IStyledOption[] = [
  { value: OPTIONS.APPROVE_ANSWER, customClass: '', icon: '' },
  { value: OPTIONS.EDIT_RFI, customClass: '', icon: '' },
  { value: OPTIONS.EDIT_QUESTION, customClass: '', icon: '' },
  { value: OPTIONS.EDIT_ANSWER, customClass: '', icon: '' },
  { value: OPTIONS.DOWNLOAD_COVER, customClass: '', icon: '' },
  { value: OPTIONS.VOID, customClass: '', icon: '' },
  { value: OPTIONS.DELETE, customClass: 'disabled text-navy-500', icon: '' },
];

export const RFI_OPTIONS_MANAGER_HAS_ANSWER_APPROVED: IStyledOption[] = [
  { value: OPTIONS.CLOSE_RFI, customClass: '', icon: '' },
  { value: OPTIONS.EDIT_RFI, customClass: '', icon: '' },
  { value: OPTIONS.EDIT_QUESTION, customClass: '', icon: '' },
  { value: OPTIONS.EDIT_ANSWER, customClass: '', icon: '' },
  { value: OPTIONS.DOWNLOAD_COVER, customClass: '', icon: '' },
  { value: OPTIONS.VOID, customClass: '', icon: '' },
  { value: OPTIONS.DELETE, customClass: 'disabled text-navy-500', icon: '' },
];

export const RFI_OPTIONS_MANAGER_HAS_ANSWER_APPROVED_ANSWERED_BY_OTHER_USER: IStyledOption[] = [
  { value: OPTIONS.CLOSE_RFI, customClass: '', icon: '' },
  { value: OPTIONS.EDIT_RFI, customClass: '', icon: '' },
  { value: OPTIONS.EDIT_QUESTION, customClass: '', icon: '' },
  { value: OPTIONS.ADD_ANSWER, customClass: '', icon: '' },
  { value: OPTIONS.DOWNLOAD_COVER, customClass: '', icon: '' },
  { value: OPTIONS.VOID, customClass: '', icon: '' },
  { value: OPTIONS.DELETE, customClass: 'disabled text-navy-500', icon: '' },
];

export const RFI_OPTIONS_MANAGER_CLOSED: IStyledOption[] = [
  { value: OPTIONS.RE_OPEN, customClass: '', icon: '' },
  { value: OPTIONS.DOWNLOAD_COVER, customClass: '', icon: '' },
];

export const RFI_OPTIONS_RESPONSIBLE_NO_ANSWER: IStyledOption[] = [
  { value: OPTIONS.ADD_ANSWER, customClass: '', icon: '' },
  { value: OPTIONS.DOWNLOAD_COVER, customClass: '', icon: '' },
];

export const RFI_OPTIONS_RESPONSIBLE_HAS_ANSWER_NON_APPROVED: IStyledOption[] = [
  { value: OPTIONS.EDIT_ANSWER, customClass: '', icon: '' },
  { value: OPTIONS.DOWNLOAD_COVER, customClass: '', icon: '' },
];

export const RFI_OPTIONS_RESPONSIBLE_HAS_ANSWER_APPROVED: IStyledOption[] = [
  { value: OPTIONS.DOWNLOAD_COVER, customClass: '', icon: '' },
];

export const RFI_OPTIONS_PARTICIPANT: IStyledOption[] = [
  { value: OPTIONS.DOWNLOAD_COVER, customClass: '', icon: '' },
];
export const RFI_OPTIONS_MANAGER_VOID: IStyledOption[] = RFI_OPTIONS_MANAGER_CLOSED;
export const RFI_OPTIONS_RESPONSIBLE_VOID: IStyledOption[] =
  RFI_OPTIONS_RESPONSIBLE_HAS_ANSWER_APPROVED;

export const RFI_DETAILS_TABS: Tab[] = [
  { value: RFI_TABS.RFI_DETAILS, icon: 'icon-folded-document-info' },
  { value: RFI_TABS.DISCUSSIONS, icon: 'icon-messages-question' },
];

export const RFI_STATUSES = [RFI_STATUS.OPEN, RFI_STATUS.CLOSED, RFI_STATUS.VOID, RFI_STATUS.DRAFT];

export const RFI_STATUS_OPTIONS = [
  { label: 'Open', value: RFI_STATUS.OPEN },
  { label: 'Closed', value: RFI_STATUS.CLOSED },
  { label: 'Void', value: RFI_STATUS.VOID },
  { label: 'Draft', value: RFI_STATUS.DRAFT },
];

export const DURATION_DAYS = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27,
  28, 29, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100, 110, 120, 130, 140, 150, 160,
  170, 180, 190, 200,
];
export const DURATION_DAY_OPTIONS = DURATION_DAYS.map((day) => ({
  label: `${day} day${day > 1 ? 's' : ''}`,
  value: day,
}));
